import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';

@Component({
  selector: 'app-request-profile-update',
  templateUrl: './request-profile-update.component.html',
  styleUrls: ['./request-profile-update.component.scss']
})
export class RequestProfileUpdateComponent implements OnInit {

  requestForm: FormGroup;

  constructor(
    private adminService: AdminService,
    private toastr: ToastrService,
    private dialogref: MatDialogRef<RequestProfileUpdateComponent>,
  ) { }

  ngOnInit(): void {

    this.requestForm = new FormGroup({
      'change_requested': new FormControl("", [Validators.required, Validators.minLength(5)])
    });

  }

  close() {
    this.dialogref.close();
  }

  submit() {    

    let form = this.requestForm.value
    this.adminService.raiseRequestProfileUpdate(form).subscribe(
      res => {
        this.toastr.success('Change Requested to Admin', 'Success');
        this.close();
      },
      err => {
        this.toastr.error('Something went wrong', 'Error');
      }
    );
  }

}
